var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container_PProgress"},[_c('div',{staticClass:"textProgress_PProgress"},[_vm._v(_vm._s(_vm.porcentage)+" %")]),_c('div',{staticClass:"progress_PProgress",style:('width:' + _vm.porcentage + '%')})])
}
var staticRenderFns = []

export { render, staticRenderFns }